// extracted by mini-css-extract-plugin
export default {"root":"ReviewDrawerHeader_root__9mNIz","name":"ReviewDrawerHeader_name__mzKP7"};